import * as React from "react";
import { Dropdown, Icon } from "semantic-ui-react";

import { connect } from "react-redux";

import { isRequestActive, LoadingState } from "redux-request-loading";

import { TextSnippet, TextSnippetState } from "./TextSnippet/model";
import { loadTextSnippets } from "./TextSnippet/actions";

import { LOAD_TEXTSNIPPETS } from "./TextSnippet/actiontypes";

interface TextSnippetSelectorOwnProps {
    onSelect: (selectedSnippet: string) => void;
}

interface TextSnippetSelectorStateProps {
    textSnippets: TextSnippet[];
    loading: boolean;
}

interface TextSnippetSelectorDispatchProps {
    loadTextSnippets: () => void;
}

interface TextSnippetStyleProps {
    padded?: boolean;
}

type Props = TextSnippetSelectorOwnProps & TextSnippetSelectorStateProps & TextSnippetSelectorDispatchProps & TextSnippetStyleProps;

class TextSnippetSelectorUnconnected extends React.Component<Props> {
    public componentDidMount() {
        if (!this.props.loading && !(this.props.textSnippets && this.props.textSnippets.length)) {
            this.props.loadTextSnippets();
        }
    }

    public textSnippetSelected(snippet: TextSnippet) {
        this.props.onSelect(snippet.text);
    }

    public render() {
        return (
            <div className={this.props.padded && "text-snippet-container"}>
                <Icon name="text cursor" />
                <Dropdown
                    inline
                    className="icon"
                    floating
                    search
                    labeled
                    text="Add text snippet"
                    loading={this.props.loading}
                >
                    <Dropdown.Menu>
                        {(this.props.textSnippets || []).map(s =>
                            (<Dropdown.Item
                                key={s.id}
                                text={s.name}
                                description={(s.text && s.text.length > 37) ? s.text.substr(0, 37) + "..."  : s.text}
                                onClick={() => this.textSnippetSelected(s)}
                            />)
                        )}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        );
    }
}

const mapStateToProps = (state: TextSnippetState & LoadingState): TextSnippetSelectorStateProps => ({
    textSnippets: state.textSnippets,
    loading: isRequestActive(state, LOAD_TEXTSNIPPETS)
});

const mapDispatchToProps = (dispatch: any): TextSnippetSelectorDispatchProps => ({
    loadTextSnippets: () => dispatch(loadTextSnippets())
});

export const TextSnippetSelector = connect(mapStateToProps, mapDispatchToProps)(TextSnippetSelectorUnconnected);
